<template>
<div class="videoEdit bgc">
    <div class="message" v-if="!realName">
        <el-alert title="" type="warning" show-icon :closable="false">请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容。</el-alert>
    </div>
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="formName" label-width="120px" class="demo-item" label-position="left" size="mini">
            <div class="classes blod">基本信息</div>
            <el-form-item label="视频名称" prop="subject" class="videoName">
                <el-input v-model.trim="item.subject" placeholder="请输入视频名称，不超过45个字" maxlength="45" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item label="视频分类" v-if="feetype === 1">
                <el-select v-model="item.columntypecode" @change="handleColumntypeChange">
                    <el-option v-for="(item, index) in columntypeList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="视频上传" prop="videoInfo" class="upload-file" required>
                <div class="upload-display" v-if="item.videoInfo.furl">
                    <span>{{item.videoInfo.fname}}</span><span class="el-upload__tip">{{fsize(item.videoInfo.fsize)}}</span>
                    <el-button type="text" size="small" @click="delUploadVidoe">删除</el-button>
                </div>
                <div class="el-upload__tip" style="margin: 0;">
                    <div>格式支持MP4，大小不超过2G，建议视频分辨率为1280×720</div>
                </div>
                <div class="upload-file-btn">
                    <uploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
                    <el-button type="warning" @click="openVideoScrollBox">素材库</el-button>
                </div>
                <!-- <img src="" id="videoFirstFrameImg" alt=""> -->
            </el-form-item>
            <el-form-item label="视频封面" prop="coverPicture" class="upload-image" required>
                <upload class="headImage" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                <div class="el-upload__tip">
                    <el-button type="warning" @click="openCoverScrollBox">素材库</el-button>
                    <div>视频封面是指在商品列表展示的图片。建议尺寸750*420px，JPG、PNG格式， 图片小于5M。 </div>
                </div>
            </el-form-item>
            <!-- <el-form-item label="视频贴片" class="upload-image">
                <upload class="headImage" :imgRule="imgRule"  @setImage="setCovertpfile" :uploadType="uploadType" ref="covertpfile"></upload>
                <div class="el-upload__tip">
                    <el-button type="warning" @click="openCovertpScrollBox">素材库</el-button>
                    <div>视频封面是指在商品列表展示的图片。建议尺寸750*420px，JPG、PNG格式， 图片小于5M。 </div>
                </div>
            </el-form-item> -->
            <el-form-item label="视频简介" class="liveName">
                <el-input type="textarea" v-model="item.description" maxlength="200" show-word-limit :rows="4"></el-input>
            </el-form-item>
            <!-- <el-form-item label="视频详情">
                <uEditor :content="item.content" ref="uEditor" @getUEditorContent="getUEditorContent" placeholder="请输入视频详情"></uEditor>
            </el-form-item> -->
            <div class="classes blod">商品信息</div>
            <el-form-item label="售卖方式">
                <promotionMsg ref="promotionMsg" @changeWay="changeWay"></promotionMsg>
            </el-form-item>
            
            <!-- <el-form-item label="商品分组" prop="description" class="shopGroup" v-if="domain === 1">
                <el-select v-model="item.divisionids" multiple placeholder="请选择" collapse-tags clearable>
                    <el-option v-for="item in shopGroupList" :key="item.innerid" :label="item.name" :value="item.innerid"> </el-option>
                </el-select>
                <el-button class="refresh" type="text" size="small" @click="_getShopGroupList">刷新</el-button>
                <el-button type="text" size="small" @click="goToShopGroup">前往商品分组</el-button>
            </el-form-item> -->
            <div class="classes blod">上架设置</div>
            <el-form-item label="上架方式" prop="onlinetype" label-width="120px" class="onLineSet">
                <!--<el-radio-group v-model="item.onlinetype" @change="switchStatus">-->
                    <!--<el-radio :label="onlinetype.code" v-for="(onlinetype, index) in onlinetypeList" :key="index">-->
                        <!--{{onlinetype.name}}-->
                        <!--<el-date-picker v-if="onlinetype.code == 2" v-model="item.onlinetime" type="datetime" placeholder="选择日期" :disabled="item.onlinetype != 2"-->
                                        <!--format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>-->
                    <!--</el-radio>-->
                <!--</el-radio-group>-->
                <!--<el-collapse class="setting">-->
                    <!--<el-collapse-item title="高级设置" name="1">-->
                        <!--<el-checkbox v-model="item.ispublic"><span>店铺内公开</span><span class="tip">上架的商品取消公开后，在店铺内不显示，但可以通过链接的方式访问</span></el-checkbox>-->
                        <!--<el-checkbox v-model="item.isplatform"><span>平台发布</span><span class="tip">官网发布，快速提高曝光率和增加浏览量</span></el-checkbox>-->
                    <!--</el-collapse-item>-->
                <!--</el-collapse>-->
                <shalfSetting :item="item"></shalfSetting>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">提交</el-button>
                <el-button type="" @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
    <scrollBox ref="coverScrollBox" :uploadType="uploadType" @saveMaterialFile="setMaterialCoverfile"></scrollBox>
    <scrollBox ref="tpScrollBox" :uploadType="uploadType" @saveMaterialFile="setMaterialCovertpfile"></scrollBox>
    <scrollBox ref="videoScrollBox" :uploadType="uploadVideoType" @saveMaterialFile="setMaterialVideofile"></scrollBox>
</div>
</template>

<script>
import Upload from 'base/upload/upload'
import UEditor from 'base/uEditor/uEditor'
import UploadFile from 'base/upload/uploadFileResume'
import PromotionMsg from 'base/promotionMsg/promotionMsg'
import ShalfSetting from 'base/promotionMsg/shalfSetting'
import {editVideo, addVideo, getVideoView, getShopGroupList} from 'api/api'
import {videoMgtCode} from 'api/enumCode'
import {mapGetters, mapActions} from 'vuex'
import {formatCheckView, formatCheckList, formatFileInfo, computeFileSize} from 'common/js/tools'
import ScrollBox from 'base/scrollBox/scrollBox'
import {videoMsg} from 'api/message'
import $ from 'jquery'
export default {
    name: 'videoEdit',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            if (!value.furl) {
                callback(new Error('请选择视频封面'))
            } else {
                callback()
            }
        }
        let validateVideoInfo = (rule, value, callback) => {
            if (!value.furl) {
                callback(new Error('请上传视频'))
            } else {
                callback()
            }
        }
        let checkOnlineWay = (rule, value, callback) => {
            if (this.item.onlinetype === 2) {
                if (!this.item.onlinetime) {
                    callback(new Error('请选择上架时间'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        return {
            onlinetypeList: videoMgtCode.onlinetype,
            feetypeList: videoMgtCode.feetype,
            realName: false,
            shopGroupList: [], // 商品分组
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            uploadVideoType: {
                catecode: '103',
                datatype: 'VIDEO'
            },
            item: {
                innerid: this.$route.query.id ? this.$route.query.id : '', // id
                subject: '', // 视频名称
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                }, // 视频封面
                tpPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                }, // 视频贴片
                content: '', // 视频详情
                vsource: '1', // 视频来源 1 直接上传 2视频素材
                videoInfo: {
                    duration: '',
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                }, // 视频
                // mktype: 1, // 票种营销类型(0 无 1限时优惠 3拼团减价 5 助力减价 6分享解锁)
                // discounttype: 2, // 优惠方式 1折扣减免 2定额减免
                // discountvalue: ', // 优惠数值
                // expirehours: '1', // 完成时间-小时
                // datacond: 1, // 使用条件( 1限时：时间，格式yyyy-MM-dd HH:mm 5 助力减价：好友助力人数，数字，大于0 6分享解锁：分享人数，默认为1)
                onlinetype: 1, // 上架方式
                onlinetime: '', // 定时时间
                divisionids: [],
                isplatform: true,
                ispublic: true,
                description: '',
                columntypecode: 'cycx',
                columntypename: '产业'
            },
            feetype: 1,
            columntypeList: [
                {label: '产业', value: 'cycx'},
                {label: '智库', value: 'sygl'},
                {label: 'PE/VC', value: 'pevc'},
                {label: '解码IPO', value: 'ss'},
                {label: '投融资', value: 'bgcz'},
                {label: '行业趋势', value: 'hyqs'},
                {label: '人物对话', value: 'rwdh'},
                {label: '活动报道', value: 'hdbd'},
                {label: '上市事件', value: 'sssj'},
                {label: '融资事件', value: 'rzsj'},
                {label: '并购事件', value: 'bgsj'},
                {label: '募资事件', value: 'mzsj'},
                {label: '财经导读', value: 'cjdd'},
                {label: '投资机会', value: 'tzjh'},
                {label: '公司聚焦', value: 'gsjj'}
            ],
            rules: {
                subject: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                    // {min: 14, max: 45, message: '长度在14到45个字符', trigger: 'blur'}
                ],
                coverPicture: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                videoInfo: [
                    {validator: validateVideoInfo, trigger: 'blur'}
                ],
                onlinetype: [
                    {required: true, message: '请选择上架方式', trigger: 'blur'},
                    {validator: checkOnlineWay, trigger: 'blur'}
                ],
                saleprice: [
                    {required: true, message: '请输入商品价格', trigger: 'blur'},
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ],
                uprice: [
                    {pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: '请输入正确的价格（2位小数）', trigger: 'blur'}
                ]
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: '',
                height: ''
            },
            fileRule: {
                btnName: '选取文件',
                cls: '',
                accept: 'video/mp4,image/png,image/jpeg',
                size: 2 * 1024,
                width: '',
                height: ''
            }
        }
    },
    mounted() {
        this._getShopGroupList()
        if (this.item.innerid) {
            this._getView()
        }
    },
    methods: {
        // 跳转商品分组
        goToShopGroup () {
            const _url = window.location.origin
            window.open(`${_url}/shopMgt/goods/goodsGroup`, '_blank')
        },
        // 删除视频
        delUploadVidoe() {
            this.item.videoInfo = {
                duration: '',
                bucket: '',
                fname: '',
                fsize: '',
                width: '',
                height: '',
                key: '',
                mimeType: '',
                objecttype: '',
                furl: ''
            }
        },
        // 打开视频素材库选择框
        openVideoScrollBox() {
            this.$refs.videoScrollBox.openDialog()
        },
        // 设置素材库选择的视频信息
        setMaterialVideofile(file) {
            this.item.vsource = '2'
            this.item.videoInfo = file
        },
        // 打开图片素材库选择框（封面）
        openCoverScrollBox() {
            this.$refs.coverScrollBox.openDialog()
        },
        // 设置素材库选择的图片信息（封面）
        setMaterialCoverfile(file) {
            this.item.coverPicture = file
            this.$refs.coverfile.setImage(this.item.coverPicture.furl)
        },
        // 打开图片素材库选择框（贴片）
        openCovertpScrollBox() {
            this.$refs.tpScrollBox.openDialog()
        },
        // 设置素材库选择的图片信息（贴片）
        setMaterialCovertpfile(file) {
            this.item.tpPicture = file
            this.$refs.covertpfile.setImage(this.item.tpPicture.furl)
        },
        // 切换收费/免费
        checkFeetype(val) {
            for (let i in this.item.checkView) {
                this.item.checkView[i].status = false
            }
            this._getShopGroupList()
        },
        // 设置视频信息（本地）
        setFile(file) {
            this.item.vsource = '1'
            this.item.videoInfo = file
            // this.handleGetVideoFirstFrame(file.furl)
        },
        // 获取视频第一帧
        handleGetVideoFirstFrame(url) {
            const imgWidth=240,imgHeight=160
            var videoElement = document.createElement("VIDEO");
            videoElement.src = url;
            videoElement.currentTime = 1
            videoElement.addEventListener("loadeddata",()=>{
                let { videoWidth, videoHeight } = videoElement;  // 获取video的宽高
                let x = 0, y = 0, width = 0, height = 0;
                // 计算缩小后图片的宽高以及canvas绘制的位置信息
                if (videoWidth / videoHeight >= 1.5) {
                    width = imgWidth ;
                    height = videoHeight * (imgWidth / videoWidth);
                    x = 0;
                    y = (imgHeight- height) / 2;
                } else {
                    height = imgHeight;
                    width = videoWidth * (imgHeight / videoHeight);
                    y = 0;
                    x = (imgWidth - width) / 2;
                } 
                var canvas = document.createElement("canvas");
                canvas.width = imgWidth ;
                canvas.height = imgHeight;
                let ctx = canvas.getContext("2d");
                ctx.fillStyle = "#000";
                ctx.fillRect(0, 0, imgWidth , imgHeight);
                ctx.drawImage(videoElement, x, y, width, height);
                let src = canvas.toDataURL("image/png"); // 完成base64图片的创建
                document.getElementById('videoFirstFrameImg').src = src
                console.log(src)
            })
        },
        // 设置封面信息（本地）
        setCoverfile(img) {
            this.item.coverPicture = img
        },
        // 设置贴片信息（本地）
        setCovertpfile(img) {
            this.item.tpPicture = img
        },
        // 视频分类
        handleColumntypeChange(columntypecode) {
            this.columntypeList.some(item => {
                if (item.value === columntypecode) {
                    this.item.columntypename = item.label
                    return true
                }
            })
        },
        // 获取富文本编辑器内容
        getUEditorContent(content) {
            this.item.content = content
        },
        cancel() {
            this.$confirm(videoMsg.cancelEdit.msg, videoMsg.cancelEdit.title, {
                confirmButtonText: videoMsg.cancelEdit.confirmText,
                cancelButtonText: videoMsg.cancelEdit.cancelText
            }).then(() => {
                this.$router.back()
            }).catch(() => {})
        },
        submitForm() {
            this.$refs.promotionMsg.$refs.sellWayForm.validate((v) => {
                this.$refs.formName.validate((valid) => {
                    if (valid && v) {
                        this.$confirm(videoMsg.submitEdit.msg, videoMsg.submitEdit.title, {
                            confirmButtonText: videoMsg.submitEdit.confirmText,
                            cancelButtonText: videoMsg.submitEdit.cancelText,
                            closeOnClickModal: false
                        }).then(() => {
                            let tmpList = formatCheckList(JSON.parse(JSON.stringify(this.$refs.promotionMsg.item.checkView)))
                            let obj = $.extend(true, {}, Object.assign({}, this.item, this.$refs.promotionMsg.item))
                            if (this.feetype === 2) {
                                obj.columntypecode = ''
                                obj.columntypename = ''
                            }
                            obj.checkView = JSON.stringify(tmpList)
                            obj.coverPicture = formatFileInfo(obj.coverPicture)
                            obj.tpPicture = formatFileInfo(obj.tpPicture)
                            obj.videoInfo = formatFileInfo(obj.videoInfo)
                            // obj.divisionids = JSON.stringify(obj.divisionids)
                            // obj.divisionids = obj.divisionids.join(',')
                            obj.divisionids = obj.divisionids.join(',')
                            obj.isplatform = obj.isplatform ? 1 : 0
                            obj.ispublic = obj.ispublic ? 1 : 0
                            if (obj.innerid) {
                                this._editObject(obj)
                            } else {
                                this._addObject(obj)
                            }
                        }).catch(() => {
                        })
                    } else {
                        return false
                    }
                })
            })
        },
        _addObject(obj) {
            this.setLoading(true)
            addVideo({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success(videoMsg.submitEdit.successMsg)
                    this.setLoading(false)
                    this.setPage({page: 1, pageSize: 10})
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editObject(obj) {
            this.setLoading(true)
            editVideo({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success(videoMsg.submitEdit.successMsg)
                    this.setLoading(false)
                    this.$router.back()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取商品分组
        _getShopGroupList () {
            // let obj = {
            //     hostinnerid: this.user.hostinnerid,
            //     totalcount: this.feetype
            // }
            this.setLoading(true)
            getShopGroupList({
                data: {},
                success: data => {
                    this.shopGroupList = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getVideoView({
                data: {
                    hostinnerid: this.user.hostinnerid,
                    innerid: this.item.innerid
                },
                success: data => {
                    data.data.checkView = formatCheckView(JSON.parse(data.data.checkView), this.$refs.promotionMsg.item.checkView)
                    this.item = data.data
                    // this.$refs.uEditor.init(this.item.content)
                    this.$refs.promotionMsg.setItem(this.item)
                    this.item.coverPicture = JSON.parse(this.item.coverPicture)
                    this.item.tpPicture = JSON.parse(this.item.tpPicture)
                    this.item.videoInfo = JSON.parse(this.item.videoInfo)
                    this.item.isplatform = this.item.isplatform === 1
                    this.item.ispublic = this.item.ispublic === 1
                    this.$refs.coverfile.setImage(this.item.coverPicture.furl)
                    if (this.item.coverPicture.furl) {
                        this.$refs.covertpfile.setImage(this.item.tpPicture.furl)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ]),
        changeWay(type) {
            this.feetype = type
            if (this.item.columntypecode === '') {
                this.item.columntypecode = 'cycx'
                this.item.columntypename = '产业'
            }
        }
    },
    filters: {},
    watch: {
        // 'feetype': {
        //     handler(newFeetype, oldFeetype) {
        //         this._getShopGroupList()
        //     }
        // },
        '$rouer': {

        },
        deep: true,
        immediate: true
    },
    computed: {
        fsize () {
            return function(size) {
                return computeFileSize(size)
            }
        },
        ...mapGetters([
            'loading',
            'user',
            'domain'
        ])
    },
    components: {
        Upload,
        UploadFile,
        UEditor,
        ScrollBox,
        PromotionMsg,
        ShalfSetting
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scpoed>
@import "~common/scss/variable";
@import "~common/scss/mixin";
.videoEdit {
    .upload-image{
        .el-form-item__content{
            @include flexBox(space-between)
        }
    }
    .account-form{
        margin-top: 20px !important;
    }
    .headImage{
        margin-right: 20px;
        .avatar-uploader{
            box-sizing: border-box;
            width: 320px;
            height: 180px;
        }
    }
    .videoName{
        .el-form-item__content{
            width: 810px;
        }
    }
    .el-upload__tip{
        width: 460px;
        color: $tcolor-grey;
        align-self: center;
        flex-grow: 1;
    }
    .upload-file{
        .upload-display{
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            box-sizing: border-box;
            background: $line;
            display: inline-block;
            border:1px solid rgba(220,223,230,1);
            span+span{
                margin-left: 20px;
            }
        }
        .upload-file-btn{
            @include flexBox(flex-start);
            .uploadFile{
                margin-right: 20px;
            }
        }
    }
    .shopGroup{
        .el-select{
            width: 278px;
        }
        .el-button{
            min-width: 0px;
            margin-right: 10px;
        }
        .refresh{
            margin-left: 12px;
        }
    }
    .el-textarea{
        width: 830px;
        textarea{
            resize: none;
        }
    }
    .el-select{
        width: 250px;
    }
}
</style>
